import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';

/**
 * 영수증 정보 삭제
 *
 * Origin: pageNicolasApi.deleteReceiptInfo
 * API: POST /api/v1/store/receipt/delete
 */
export async function postStoreReceiptDelete(
  options?: FetcherOptions
): Promise<ApiResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/store/receipt/delete',
    {
      method: 'POST',
    },
    options
  );
  return response.data;
}
